import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Home } from 'lucide-react';

/**
 * PageNavigation Component
 * Provides consistent navigation across all pages with:
 * - Back button (arrow + "Back" text)
 * - Dashboard button (home + "Dashboard" text)
 * Style matches Skills Gap Analysis page
 */
const PageNavigation = ({ 
  showBackToPrevious = true,
  showBackToDashboard = true,
  dashboardPath = '/dashboard',
  className = ''
}) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(dashboardPath);
    }
  };

  const goToDashboard = () => {
    navigate(dashboardPath);
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {showBackToPrevious && (
        <Button variant="outline" size="sm" onClick={goBack}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
      )}
      {showBackToDashboard && (
        <Button variant="outline" size="sm" onClick={goToDashboard}>
          <Home className="w-4 h-4 mr-2" />
          Dashboard
        </Button>
      )}
    </div>
  );
};

export default PageNavigation;
